import { useReadingProgress } from '@/legal/hooks/useReadingProgress';

export function ReadingProgress() {
  const progress = useReadingProgress();
  return (
    <div className="fixed left-0 right-0 top-0 z-40 h-1 bg-transparent" aria-hidden>
      <div
        className="h-full bg-action-primary-bg transition-[width]"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
